module.exports = __webpack_public_path__ + "1793882494189/images/mastercard2.478335a.png";